export const PERMS = {
    READ: 'report_transport_changes.read',
    UPDATE: 'report_transport_changes.update',
    DELETE: 'report_transport_changes.delete',
    CREATE: 'report_transport_changes.create',
    EXPORT: 'report_transport_changes.export',
}
